import { render, staticRenderFns } from "./editParkingArea.vue?vue&type=template&id=70c97c1a&scoped=true"
import script from "./editParkingArea.vue?vue&type=script&lang=js"
export * from "./editParkingArea.vue?vue&type=script&lang=js"
import style0 from "./editParkingArea.vue?vue&type=style&index=0&id=70c97c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c97c1a",
  null
  
)

export default component.exports